import React from "react";
import Header from "../Header/Header";
import PropTypes from "prop-types";

export default function Layout({ children }) {
  return (
    <>
      <Header />
      {children}
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,       
};